import auth from './modules/auth';
import app from './modules/app';
import account from './modules/account';
import billing from './modules/billing';
import schedule from './modules/schedule';
import pay from './modules/pay';
import payNDP from './modules/payNDP';
import usage from './modules/usage';
import reports from './modules/reports';
import practice from './modules/practice';
import futurecare from './modules/futurecare';
import practices from './modules/practices';
import caredelta from './modules/caredelta';
import docs from './modules/docs';
import clinicalConstitution from "./modules/clinicalConstitution";
import help from './modules/help';
import timeoffRequests from './modules/timeoffRequests';
import manageProfile from './modules/manageProfile';
import bgoal from './modules/bgoal';
import bitewingReport from './modules/bitewingReport';
import payReports from './modules/payReports';
import payReportsNDP from './modules/payReportsNDP';
import statusCodes from './modules/statusCodes';
import earningsSending from "./modules/earningsSending";
import downTimeTracker from "./modules/downTimeTracker"
import payValidation from './modules/payValidation';
import orthoEarningsSending from "./modules/orthoEarningsSending";
import sageAccounts from './modules/sageAccounts';
import treatingDoctor from './modules/treatingDoctor';
import performanceScoreCard from './modules/performanceScoreCard';
import dataFile from './modules/dataFile';
import hynTracker from './modules/hynTracker';
import providerExpenses from './modules/providerExpenses';

export default {
  auth,
  app,
  account,
  schedule,
  billing,
  pay,
  payNDP,
  usage,
  reports,
  practice,
  futurecare,
  clinicalConstitution,
  practices,
  caredelta,
  docs,
  help,
  timeoffRequests,
  manageProfile,
  bgoal,
  bitewingReport,
  payReports,
  payReportsNDP,
  statusCodes,
  earningsSending,
  downTimeTracker,
  payValidation,
  orthoEarningsSending,
  sageAccounts,
  treatingDoctor,
  performanceScoreCard,
  hynTracker,
  dataFile,
  providerExpenses,
};
